import React from "react";

function CTAActionSelector({
  actionType,
  setActionType,
  setDestination,
}) {

  const handleChange = (event) => {

    const value = event.target.value;

    setActionType(value);

    /*
      Set an example destination based
      on the selected action.
    */

    switch (value) {

      case "URL":
        setDestination("");
        break;

      case "Registration Page":
        setDestination("/registration");
        break;

      case "Booking Page":
        setDestination("/book-demo");
        break;

      case "Demo Form":
        setDestination("/demo-form");
        break;

      case "Lead Form":
        setDestination("/lead-form");
        break;

      default:
        setDestination("");
    }
  };


  return (
    <div className="mb-4">

      <label className="form-label fw-semibold">
        CTA Action
      </label>

      <select
        className="form-select"
        value={actionType}
        onChange={handleChange}
      >

        <option value="URL">
          Open URL
        </option>

        <option value="Registration Page">
          Registration Page
        </option>

        <option value="Booking Page">
          Booking Page
        </option>

        <option value="Demo Form">
          Demo Form
        </option>

        <option value="Lead Form">
          Lead Form
        </option>

      </select>

      <div className="form-text">
        Select what should happen when the visitor
        clicks this CTA.
      </div>

    </div>
  );
}

export default CTAActionSelector;